import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { HttpClient, HttpHeaders, HttpParams, HttpResponse } from '@angular/common/http';
import { Observable, catchError } from 'rxjs';
import { GlobalServicesService } from './global-services.service';

@Injectable({
  providedIn: 'root'
})
export class SettingsService {

  host_api_url = environment.HOST.HOST_API_URL;
  fast_api_url = environment.HOST.FAST_API_URL;

  constructor(private http: HttpClient,private globalService: GlobalServicesService) { }

  //Fast API
  getCompanyDataFastApi(): Observable<HttpResponse<any>> {
    return this.http.get<HttpResponse<any>>(this.fast_api_url + '/company-details', {
      observe: 'response',
    }).pipe(
      catchError(this.globalService.handleError.bind(this.globalService))
    );
  }
  
  updateCompanyDataFastApi(payload: any): Observable<HttpResponse<any>> {
    return this.http.patch<HttpResponse<any>>(this.fast_api_url + '/company-details', payload, {
      observe: 'response',
    }).pipe(
      catchError(this.globalService.handleError.bind(this.globalService))
    );
  }
  
  getBranchDataFastApi(): Observable<HttpResponse<any>> {
    return this.http.get<HttpResponse<any>>(this.fast_api_url + '/branches', {
      observe: 'response',
    }).pipe(
      catchError(this.globalService.handleError.bind(this.globalService))
    );
  }
  
  createBranchDataFastApi(payload: any): Observable<HttpResponse<any>> {
    return this.http.post<HttpResponse<any>>(this.fast_api_url + '/branches', payload, {
      observe: 'response',
    }).pipe(
      catchError(this.globalService.handleError.bind(this.globalService))
    );
  }
  
  getSpecificBranchDataFastApi(id: string): Observable<HttpResponse<any>> {
    return this.http.get<HttpResponse<any>>(this.fast_api_url + '/branches/' + id, {
      observe: 'response',
    }).pipe(
      catchError(this.globalService.handleError.bind(this.globalService))
    );
  }
  
  updateSpecificBranchDataFastApi(id: string, payload: any): Observable<HttpResponse<any>> {
    return this.http.put<HttpResponse<any>>(this.fast_api_url + '/branches/' + id, payload, {
      observe: 'response',
    }).pipe(
      catchError(this.globalService.handleError.bind(this.globalService))
    );
  }
  
  deleteSpecificBranchDataFastApi(id: string): Observable<HttpResponse<any>> {
    return this.http.delete<HttpResponse<any>>(this.fast_api_url + '/branches/' + id, {
      observe: 'response',
    }).pipe(
      catchError(this.globalService.handleError.bind(this.globalService))
    );
  }
  
  emailVerifyFastApi(payload: any): Observable<HttpResponse<any>> {
    return this.http.post<HttpResponse<any>>(this.fast_api_url + '/profile/change-email', payload, {
      observe: 'response',
    }).pipe(
      catchError(this.globalService.handleError.bind(this.globalService))
    );
  }
  
  emailUpdateFastApi(payload: any): Observable<HttpResponse<any>> {
    return this.http.put<HttpResponse<any>>(this.fast_api_url + '/profile/update-email', payload, {
      observe: 'response',
    }).pipe(
      catchError(this.globalService.handleError.bind(this.globalService))
    );
  }
  
  changePasswordFastApi(payload: any): Observable<HttpResponse<any>> {
    return this.http.post<HttpResponse<any>>(this.fast_api_url + '/auth/change-password', payload, {
      observe: 'response',
    }).pipe(
      catchError(this.globalService.handleError.bind(this.globalService))
    );
  }
  
  // candidate source name
  getCandidateSourceNameFastApi(page = 1, size = 100, orderBy = 'asc', sortBy = 'id'): Observable<HttpResponse<any>> {
    const params = new HttpParams()
      .set('page', page.toString())
      .set('size', size.toString())
      .set('order_by', orderBy)
      .set('sort_by', sortBy);
  
    return this.http.get<HttpResponse<any>>(this.fast_api_url + '/candidate-sources', {
      params,
      observe: 'response',
    }).pipe(
      catchError(this.globalService.handleError.bind(this.globalService))
    );
  }
  
  getSpecificCandidateSourceFastApi(id: string): Observable<HttpResponse<any>> {
    return this.http.get<HttpResponse<any>>(this.fast_api_url + '/candidate-sources/' + id, {
      observe: 'response',
    }).pipe(
      catchError(this.globalService.handleError.bind(this.globalService))
    );
  }
  
  addCandidateSourceFastApi(payload: any): Observable<HttpResponse<any>> {
    return this.http.post<HttpResponse<any>>(this.fast_api_url + '/candidate-sources', payload, {
      observe: 'response',
    }).pipe(
      catchError(this.globalService.handleError.bind(this.globalService))
    );
  }
  
  updateCandidateSourceFastApi(id: string, payload: any): Observable<HttpResponse<any>> {
    return this.http.put<HttpResponse<any>>(this.fast_api_url + '/candidate-sources/' + id, payload, {
      observe: 'response',
    }).pipe(
      catchError(this.globalService.handleError.bind(this.globalService))
    );
  }
  
  deleteCandidateSourceFastApi(id: string): Observable<HttpResponse<any>> {
    return this.http.delete<HttpResponse<any>>(this.fast_api_url + '/candidate-sources/' + id, {
      observe: 'response',
    }).pipe(
      catchError(this.globalService.handleError.bind(this.globalService))
    );
  }
  
  // event category
  getEventCategoryFastApi(page = 1, size = 100, orderBy = 'asc', sortBy = 'id'): Observable<HttpResponse<any>> {
    const params = new HttpParams()
      .set('page', page.toString())
      .set('size', size.toString())
      .set('order_by', orderBy)
      .set('sort_by', sortBy);
  
    return this.http.get<HttpResponse<any>>(this.fast_api_url + '/event-categories', {
      params,
      observe: 'response',
    }).pipe(
      catchError(this.globalService.handleError.bind(this.globalService))
    );
  }
  
  getSpecificEventCategoryFastApi(id: string): Observable<HttpResponse<any>> {
    return this.http.get<HttpResponse<any>>(this.fast_api_url + '/event-categories/' + id, {
      observe: 'response',
    }).pipe(
      catchError(this.globalService.handleError.bind(this.globalService))
    );
  }
  
  addEventCategoryFastApi(payload: any): Observable<HttpResponse<any>> {
    return this.http.post<HttpResponse<any>>(this.fast_api_url + '/event-categories', payload, {
      observe: 'response',
    }).pipe(
      catchError(this.globalService.handleError.bind(this.globalService))
    );
  }
  
  updateEventCategoryFastApi(id: string, payload: any): Observable<HttpResponse<any>> {
    return this.http.put<HttpResponse<any>>(this.fast_api_url + '/event-categories/' + id, payload, {
      observe: 'response',
    }).pipe(
      catchError(this.globalService.handleError.bind(this.globalService))
    );
  }
  
  deleteEventCategoryFastApi(id: string): Observable<HttpResponse<any>> {
    return this.http.delete<HttpResponse<any>>(this.fast_api_url + '/event-categories/' + id, {
      observe: 'response',
    }).pipe(
      catchError(this.globalService.handleError.bind(this.globalService))
    );
  }
  
  // event type
  getEventTypeFastApi(page = 1, size = 100, orderBy = 'asc', sortBy = 'id'): Observable<HttpResponse<any>> {
    const params = new HttpParams()
      .set('page', page.toString())
      .set('size', size.toString())
      .set('order_by', orderBy)
      .set('sort_by', sortBy);
  
    return this.http.get<HttpResponse<any>>(this.fast_api_url + '/event-types', {
      params,
      observe: 'response',
    }).pipe(
      catchError(this.globalService.handleError.bind(this.globalService))
    );
  }
  
  getSpecificEventTypeFastApi(id: string): Observable<HttpResponse<any>> {
    return this.http.get<HttpResponse<any>>(this.fast_api_url + '/event-types/' + id, {
      observe: 'response',
    }).pipe(
      catchError(this.globalService.handleError.bind(this.globalService))
    );
  }
  
  addEventTypeFastApi(payload: any): Observable<HttpResponse<any>> {
    return this.http.post<HttpResponse<any>>(this.fast_api_url + '/event-types', payload, {
      observe: 'response',
    }).pipe(
      catchError(this.globalService.handleError.bind(this.globalService))
    );
  }
  
  updateEventTypeFastApi(id: string, payload: any): Observable<HttpResponse<any>> {
    return this.http.put<HttpResponse<any>>(this.fast_api_url + '/event-types/' + id, payload, {
      observe: 'response',
    }).pipe(
      catchError(this.globalService.handleError.bind(this.globalService))
    );
  }
  
  deleteEventTypeFastApi(id: string): Observable<HttpResponse<any>> {
    return this.http.delete<HttpResponse<any>>(this.fast_api_url + '/event-types/' + id, {
      observe: 'response',
    }).pipe(
      catchError(this.globalService.handleError.bind(this.globalService))
    );
  }
  // role type APIs (Fast API)
  getRoleTypesFastApi(page = 1, size = 100, orderBy = 'asc', sortBy = 'id'): Observable<HttpResponse<any>> {
    const params = new HttpParams()
      .set('page', page.toString())
      .set('size', size.toString())
      .set('order_by', orderBy)
      .set('sort_by', sortBy);

    return this.http.get<HttpResponse<any>>(this.fast_api_url + '/role-types', {
      params,
      observe: 'response',
    }).pipe(
      catchError(this.globalService.handleError.bind(this.globalService))
    );
  }

  getSpecificRoleTypeFastApi(id: string): Observable<HttpResponse<any>> {
    return this.http.get<HttpResponse<any>>(this.fast_api_url + '/role-types/' + id, {
      observe: 'response',
    }).pipe(
      catchError(this.globalService.handleError.bind(this.globalService))
    );
  }

  addRoleTypeFastApi(payload: any): Observable<HttpResponse<any>> {
    return this.http.post<HttpResponse<any>>(this.fast_api_url + '/role-types', payload, {
      observe: 'response',
    }).pipe(
      catchError(this.globalService.handleError.bind(this.globalService))
    );
  }

  updateRoleTypeFastApi(id: string, payload: any): Observable<HttpResponse<any>> {
    return this.http.put<HttpResponse<any>>(this.fast_api_url + '/role-types/' + id, payload, {
      observe: 'response',
    }).pipe(
      catchError(this.globalService.handleError.bind(this.globalService))
    );
  }

  deleteRoleTypeFastApi(id: string): Observable<HttpResponse<any>> {
    return this.http.delete<HttpResponse<any>>(this.fast_api_url + '/role-types/' + id, {
      observe: 'response',
    }).pipe(
      catchError(this.globalService.handleError.bind(this.globalService))
    );
  }
  updateAccount(payload: any): Observable<any>{
    return this.http.put(this.fast_api_url + '/primaryAccount/update/details', payload, {
      headers: new HttpHeaders({ 'use-candidate-token': 'true' })
    });
  }

  
    // Conference Integration APIs
    getConferenceProviders(): Observable<HttpResponse<any>> {
        return this.http.get<HttpResponse<any>>(this.fast_api_url + '/integrations/conference/providers', {
            observe: 'response',
        }).pipe(
            catchError(this.globalService.handleError.bind(this.globalService))
        );
    }

    connectConferenceProvider(providerKey: string): Observable<HttpResponse<any>> {
        return this.http.get<HttpResponse<any>>(this.fast_api_url + '/integrations/conference/' + providerKey + '/connect', {
            observe: 'response',
        }).pipe(
            catchError(this.globalService.handleError.bind(this.globalService))
        );
    }

    revokeConferenceProvider(providerKey: string): Observable<HttpResponse<any>> {
        return this.http.delete<HttpResponse<any>>(this.fast_api_url + '/integrations/conference/' + providerKey + '/revoke', {
            observe: 'response',
        }).pipe(
            catchError(this.globalService.handleError.bind(this.globalService))
        );
    }

    getConferenceProviderProfile(providerKey: string): Observable<HttpResponse<any>> {
        return this.http.get<HttpResponse<any>>(this.fast_api_url + '/integrations/conference/' + providerKey + '/profile', {
            observe: 'response',
        }).pipe(
            catchError(this.globalService.handleError.bind(this.globalService))
        );
    }
}
